import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Typography, Button } from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox } from '../../styles/styles';
import { CustomTable, FilterPlaceholder } from '../../common/CustomTable';
import Spinner from '../../util/Spinner';

const columns = [
  {
    Header: 'Template Name',
    accessor: 'Name',
    Filter: FilterPlaceholder,
  },
  {
    Header: 'Description',
    accessor: 'Description',
  },
];

const DealTemplates = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(false);
  const [dealTemplates, setDealTemplates] = useState([]);
  useEffect(() => {
    const initialize = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/deal-templates`,
        );
        setDealTemplates(data);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    initialize();
  }, []);

  if (isLoading) return <Spinner />;

  return (
    <FlexDiv>
      <WideBox style={{ maxWidth: '1200px', width: '98%' }}>
        <CustomTable
          data={dealTemplates}
          columns={columns}
          minRows={1}
          trClassName="react-table-hover-row"
          getTrProps={({ row }) => ({
            onClick: () =>
              history.push(`/deal-template/${row.original.DealTemplateId}`),
          })}
          tableHeader={<Typography variant="h2">Deal Templates</Typography>}
          actionables={
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to="/deal-templates/new"
            >
              <CirclePlusIcon
                style={{ marginRight: '4px', marginLeft: '-3px' }}
              />
              New Template
            </Button>
          }
          containerStyle={{ padding: '0 2rem' }}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default DealTemplates;
